<template>
<section class="flex flex-col xl:flex-row items-center xl:px-10 lg:px-8 md:px-8 px-2 py-8 md:py-10 xl:py-16 bg-[#186a85] text-white relative overflow-hidden font-poppins antialiased gap-10">
  
    <!-- Image Content (Kiri di XL, Bawah di Mobile) -->
    <div class="w-full flex justify-center items-center order-last xl:order-none">
      <img src="@/assets/workflow.svg" alt="Workflow Image" class="w-full ">
    </div>
  
    <!-- Text Content (Kanan) -->
    <div class="w-full px-6 md:px-12 lg:px-16 text-start">
      <div class="flex items-center justify-start mb-4">
        <div class="h-7 rounded-lg w-1 bg-white"></div>
        <span class="px-2 py-2 bg-opacity-20 text-white text-md tracking-wider">Work Flow</span>
      </div>
      <h2 class="text-white text-2xl md:text-3xl font-semibold mb-3 leading-tight">
        Our Working Process
      </h2>
      <p class="text-white text-sm md:text-md leading-relaxed">
        We ensure optimal results through a structured yet flexible workflow.
      </p>
  
      <div class="space-y-4 pt-5">
        <div class="flex items-center space-x-3">
          <img src="@/assets/Planning.svg" alt="Planning Icon" class="h-10 w-10 filter invert brightness-0">
          <h4 class="text-lg font-normal">01 - Planning</h4>
        </div>
        <div class="flex items-center space-x-3">
          <img src="@/assets/Execution.svg" alt="Execution Icon" class="h-10 w-10 filter invert brightness-0">
          <h4 class="text-lg font-normal">02 - Execution</h4>
        </div>
        <div class="flex items-center space-x-3">
          <img src="@/assets/Review.svg" alt="Review Icon" class="h-10 w-10 filter invert brightness-0">
          <h4 class="text-lg font-normal">03 - Review</h4>
        </div>
        <div class="flex items-center space-x-3">
          <img src="@/assets/Improvement.svg" alt="Improvement Icon" class="h-10 w-10 filter invert brightness-0">
          <h4 class="text-lg font-normal">04 - Continuous Improvement</h4>
        </div>
      </div>
    </div>
  
  </section>
  
  </template>